import { useMemo } from 'react'
import PropTypes from 'prop-types'

import '../../styles/components/picturesModal/pictures-modal.scss'
import { getAssetLink } from '../../helpers/get-asset-link'
import ImageViewer from '../ImageViewer/ImageViewer'

const PicturesModal = ({
  assetPath,
  useDirectLinks = false,
  fallback,
  visible,
  pictures,
  indexToShow,
  onCloseModal,
  contentStyle = {},
  bodyStyle = {},
}) => {
  const filteredPictures = useMemo(() => {
    return pictures.filter((picUrl) => !!picUrl)
  }, [pictures])

  const getImageLink = (file) => {
    if (useDirectLinks) {
      return file
    }

    return getAssetLink({
      path: assetPath,
      file,
      fallback,
    })
  }

  return (
    <div
      className={`modal pictures-modal modal--organisation modal--service modal--product ${
        visible ? 'is-active' : ''
      }`}
    >
      <div className="modal-background" onClick={() => onCloseModal()} />
      <div className="modal-content" style={contentStyle}>
        <div className="box">
          <header className="modal__header pictures-modal__header">
            <div>{filteredPictures.length > 1 ? 'Pictures' : 'Picture'}</div>
            <div
              className="pictures-modal__header pictures-modal__header-close"
              onClick={() => onCloseModal()}
            >
              X
            </div>
          </header>
          <div className="pictures-modal__body" style={bodyStyle}>
            <ImageViewer
              images={filteredPictures}
              indexToShow={filteredPictures.length ? indexToShow : 0}
              getImagesMethod={getImageLink}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

PicturesModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  pictures: PropTypes.arrayOf(PropTypes.string).isRequired,
  indexToShow: PropTypes.number,
  onCloseModal: PropTypes.func.isRequired,
  contentStyle: PropTypes.object,
  bodyStyle: PropTypes.object,
  useDirectLinks: PropTypes.bool,
  fallback: PropTypes.string,
}

export default PicturesModal
